import { render, staticRenderFns } from "./Panjabi.vue?vue&type=template&id=8119e350&scoped=true"
import script from "./Panjabi.vue?vue&type=script&lang=js"
export * from "./Panjabi.vue?vue&type=script&lang=js"
import style0 from "./Panjabi.vue?vue&type=style&index=0&id=8119e350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8119e350",
  null
  
)

export default component.exports